window.fontAwesomeFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<i class="font-awesome fa ' + value + '"></i>';
    }
    return html;
};
